import { useEffect, useState } from "react";
import { api, fmtDateTime, titleCase } from "@/lib/api";
import { Panel, Status, Rag, Empty } from "@/components/common";

export function CaseNotificationsTab({ c }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/notifications/case/${c.id}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [c.id]);
  return (
    <Panel title="Notification Engine — portal, email, SMS" className="mt-4" testId="case-notifications-panel">
      {items.length === 0 ? <Empty text="No notifications yet" /> : (
        <div className="-m-5 overflow-x-auto"><table className="tbl"><thead><tr><th>When</th><th>Channel</th><th>Subject</th><th>Kind</th><th>Delivery</th></tr></thead>
          <tbody>{items.map((n) => <tr key={n.id} data-testid="case-notification-row"><td className="mono text-xs">{fmtDateTime(n.created_at)}</td><td className="text-xs uppercase mono">{n.channel}</td><td><div className="text-sm font-medium">{n.subject}</div><div className="text-xs text-slate-500">{n.body}</div></td><td className="text-xs">{titleCase(n.kind)}{n.triage && <> · <Rag level={n.triage} label={n.triage} /></>}</td><td><Status value={n.status} /></td></tr>)}</tbody></table></div>)}
    </Panel>
  );
}

export function CaseAuditTab({ c }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/audit/case/${c.id}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [c.id]);
  return <AuditTable items={items} title="Immutable audit log — this case" />;
}

export function AuditTable({ items, title, testId = "audit-table" }) {
  return (
    <Panel title={title} className="mt-4" testId="audit-panel">
      <div className="-m-5 overflow-x-auto"><table className="tbl" data-testid={testId}><thead><tr><th>#</th><th>Timestamp</th><th>Actor</th><th>Action</th><th>Entity</th><th>Details</th><th>Hash chain</th></tr></thead>
        <tbody>{items.map((e) => (
          <tr key={e.id} data-testid={`audit-row-${e.seq}`}><td className="mono text-xs">{e.seq}</td><td className="mono text-xs">{fmtDateTime(e.timestamp)}</td>
            <td><div className="text-sm">{e.actor_name}</div><span className="text-[10px] uppercase tracking-wider bg-slate-100 border border-slate-200 rounded px-1">{e.actor_role}</span></td>
            <td className="mono text-xs text-blue-900">{e.action}</td><td className="text-xs">{e.entity_type}{e.case_id && <div className="text-slate-400">case {e.case_id.slice(0, 8)}</div>}</td>
            <td className="text-xs text-slate-600 max-w-xs truncate" title={JSON.stringify(e.details)}>{JSON.stringify(e.details)}</td>
            <td className="mono text-[10px] text-slate-500">{e.hash.slice(0, 12)}…<div className="text-slate-300">← {e.prev_hash.slice(0, 12)}</div></td></tr>))}</tbody></table></div>
    </Panel>
  );
}
